import { render, staticRenderFns } from "./mainBannerStar.vue?vue&type=template&id=e5585662&scoped=true&"
import script from "./mainBannerStar.vue?vue&type=script&lang=js&"
export * from "./mainBannerStar.vue?vue&type=script&lang=js&"
import style0 from "./mainBannerStar.vue?vue&type=style&index=0&id=e5585662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5585662",
  null
  
)

export default component.exports